import { regionFormat } from '@/lib/region-format';

/** Cents in the amount's own currency (the region's when blank), in the region's locale. */
export function fmtCurrency(cents: number, currency: string): string {
  return regionFormat.formatCents(cents, { currency });
}

export function fmtDateTime(value: string | null): string {
  if (!value) return '—';
  return regionFormat.formatDateTime(value);
}

export function fmtWhen(value: string | null, opts: { past?: 'overdue' | 'done' | 'plain' } = {}): string {
  if (!value) return '—';
  const d = new Date(value.length <= 10 ? `${value}T00:00:00` : value);
  const abs = regionFormat.formatDate(d, { month: 'short', day: 'numeric' });
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  const startOfTarget = new Date(d);
  startOfTarget.setHours(0, 0, 0, 0);
  const days = Math.round((startOfTarget.getTime() - startOfToday.getTime()) / 86_400_000);
  if (days === 0) return `today · ${abs}`;
  if (days > 0) return `in ${days}d · ${abs}`;
  const ago = Math.abs(days);
  const past = opts.past ?? 'plain';
  if (past === 'overdue') return `overdue ${ago}d · ${abs}`;
  if (past === 'done') return `${ago}d ago · ${abs}`;
  return abs;
}

// A failed manual charge has no next attempt; its anchor date keeps it in place.
export function billingChargeSortTime(charge: { status: string; paidAt?: string | null; nextAttemptAt: string | null; anchorDate: string }): number {
  const value = (charge.status === 'succeeded' ? charge.paidAt ?? charge.nextAttemptAt : charge.nextAttemptAt) ?? charge.anchorDate;
  const time = new Date(value).getTime();
  return Number.isFinite(time) ? time : 0;
}
